import React from 'react';
import { useTranslation } from 'react-i18next';
import css from '../index.module.css';

export default function TableHeadings() {
  const { t } = useTranslation();

  return (
    <div className={css['table-head']}>
      <div className={css['table-data']}></div>
      <div className={css['table-data']}>
        {t('pages.finance.budget.heading.total')}
      </div>
      <div className={css['table-data']}></div>
    </div>
  );
}
